import LoginLayout from "../LoginLayout"
import { connect } from "react-redux"
import { FormPageProps, ResetPasswordFormValues } from "../../../../types"
import ResetPasswordForm from "./ResetPasswordForm"
import { resetPassword } from "../../../../actions/loginActions"
import { useNavigate, useParams } from "react-router-dom"
//@ts-ignore
import EyeIcon from "../../../ui/img/auth/eye.svg"
//@ts-ignore
import EyeSlashIcon from "../../../ui/img/auth/eye-slash.svg"
//@ts-ignore
import PasswordIcon from "../../../ui/img/auth/password.svg"
import React, { useEffect, useState } from "react"
import { KButton, KInput, KTitleSpan } from "kahuna-base-react-components"
import { lang } from "../../../../constants/languages"
import { errorFilledToastOptions } from "../../../../constants"
import { toast } from "react-toastify"

const ResetPassword = (props: FormPageProps<ResetPasswordFormValues>) => {
  const [form, setForm] = useState<ResetPasswordFormValues>({ email: "" })
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordAgain, setShowPasswordAgain] = useState(false)

  const navigate = useNavigate()
  const params = useParams()
  const onSubmit = () => {
    if (form.password !== form.repeatedPassword) {
      toast.error(lang.reset_password.password_do_not_match, errorFilledToastOptions)
      return
    }
    props.onSubmit(form, () => navigate("/login"))
  }

  useEffect(() => {
    setForm({ ...form, email: params.email })
  }, [])

  return (
    <LoginLayout>
      <div className={"grid align-middle justify-center items-center"} style={{ width: "100%", height: "90%" }}>
        <div className={"grid"} style={{ width: 500 }}>
          <div className={"flex"}>
            <KTitleSpan text={lang.reset_password.title} />
          </div>
          <div className={"mt-8"}>
            <KInput
              type="number"
              value={form.code || ""}
              onChange={(text) => setForm({ ...form, code: text })}
              placeholder={lang.reset_password.code_placeholder}
            />
          </div>
          <div className={"mt-4"}>
            <KInput
              value={form.password || ""}
              onChange={(text) => setForm({ ...form, password: text })}
              type={showPassword ? "text" : "password"}
              placeholder={lang.reset_password.password_placeholder}
              leftIcon={PasswordIcon}
              rightIconClick={() => setShowPassword(!showPassword)}
              rightIcon={showPassword ? EyeIcon : EyeSlashIcon}
            />
          </div>
          <div className={"mt-4"}>
            <KInput
              value={form.repeatedPassword || ""}
              onChange={(text) => setForm({ ...form, repeatedPassword: text })}
              type={showPasswordAgain ? "text" : "password"}
              placeholder={lang.reset_password.repeat_password_placeholder}
              leftIcon={PasswordIcon}
              rightIconClick={() => setShowPasswordAgain(!showPasswordAgain)}
              rightIcon={showPasswordAgain ? EyeIcon : EyeSlashIcon}
            />
          </div>
          <div className={"mt-8"}>
            <KButton
              onClick={() => onSubmit()}
              text={lang.reset_password.reset_password_button}
              background="#111"
              textColor="white"
            />
            <div className="mt-2">
              <KButton
                shadowDisabled={true}
                background="transparent"
                onClick={() => navigate(`/login?username=${form.email}`)}
                text={lang.reset_password.return_to_login_button}
              />
            </div>
          </div>
        </div>
      </div>
    </LoginLayout>
  )
}

export default connect(null, { onSubmit: resetPassword })(ResetPassword)
